import script from "./DatmaLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./DatmaLogo.vue?vue&type=script&setup=true&lang=js"

import "./DatmaLogo.vue?vue&type=style&index=0&id=0a9e2a46&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a9e2a46"]])

export default __exports__